import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Socials from "./components/Socials";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Contact from "./components/Contact";

function App() {
  return (
    <div>
      <Navbar />
      <Home />
      <Socials />
      <About />
      <Projects />
      <Skills />
      <Contact />
    </div>
  );
}

export default App;
